/* =========================================================
   Canyon (OS2.0) — TOP filters (Product type + Vendor)
   FIX: 1-click toggle in Theme Editor + narrower width
   ========================================================= */

(function () {
  function isCollectionPage() {
    const p = window.location.pathname || "";
    return p.includes("/collections/") && !p.includes("/products/");
  }

  function oncePerPage(key) {
    const k = `__gsw_${key}`;
    if (window[k]) return false;
    window[k] = true;
    return true;
  }

  function injectStyles() {
    if (document.getElementById("gsw-top-filters-css")) return;
    const style = document.createElement("style");
    style.id = "gsw-top-filters-css";
    style.textContent = `
      /* NARROWER WRAPPER */
      .gsw-filters-top{
        display:inline-block;             /* <- prevents full-width stretch */
        width: min(720px, 100%);          /* <- narrower */
        margin: 6px 0 10px;
        padding: 8px 10px;
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 12px;
        background:#fff;

        position: relative;
        z-index: 999999;
        isolation: isolate;
        pointer-events: auto !important;
      }
      .gsw-filters-top, .gsw-filters-top *{ pointer-events:auto !important; }

      .gsw-filters-top-head{ font-weight:800; font-size:14px; margin:0 0 6px; }

      /* Two compact columns */
      .gsw-filters-top-grid{
        display:grid;
        grid-template-columns: minmax(260px, 340px) minmax(260px, 340px);
        gap:10px 12px;
        align-items:start;
      }
      @media(max-width:990px){
        .gsw-filters-top{ display:block; width:100%; }
        .gsw-filters-top-grid{ grid-template-columns: 1fr; gap:10px; }
      }

      .gsw-filter-card{
        border:1px solid rgba(0,0,0,.06);
        border-radius:12px;
        padding:8px 10px;
      }
      .gsw-filter-title{ font-weight:800; font-size:13px; margin:0 0 6px; }

      .gsw-filter-body{
        max-height: 170px;
        overflow:auto;
        padding-right:4px;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
      }

      /* FULL row clickable */
      .gsw-opt{
        display:flex;
        align-items:center;
        gap:10px;
        width:100%;
        padding:8px 10px;
        border-radius:10px;
        cursor:pointer;
        user-select:none;
        touch-action: manipulation;
      }
      .gsw-opt:hover{ background:rgba(0,0,0,.04); }

      .gsw-opt input{
        width:16px; height:16px;
        flex:0 0 auto;
        position:relative;
        z-index:2;
      }
      .gsw-opt span{ flex:1 1 auto; }

      .gsw-hide-original{ display:none !important; }
    `;
    document.head.appendChild(style);
  }

  function isInDrawer(el) {
    if (!el) return false;
    return !!el.closest(
      "menu-drawer, .drawer, .drawer__inner, [data-drawer], [id*='Drawer'], [class*='drawer']"
    );
  }

  function isVisibleEl(el) {
    if (!el) return false;
    if (el.offsetParent === null) return false;
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function pickSourceRoot() {
    const all = Array.from(document.querySelectorAll('input[name^="filter.p.vendor"]'));
    const candidate =
      all.find(i => !isInDrawer(i) && isVisibleEl(i)) ||
      all.find(i => !isInDrawer(i)) ||
      all[0];
    if (!candidate) return null;

    return (
      candidate.closest("#FacetFiltersForm") ||
      candidate.closest("facet-filters-form") ||
      candidate.closest("form") ||
      candidate.closest(".facets") ||
      candidate.closest(".facet-filters") ||
      document
    );
  }

  function findInputsInRoot(root, namePrefix) {
    if (!root) return [];
    return Array.from(root.querySelectorAll(`input[name^="${namePrefix}"]`))
      .filter(i => i.type === "checkbox")
      .filter(i => !isInDrawer(i));
  }

  function dedupeInputs(inputs) {
    const seen = new Set();
    const out = [];
    for (const i of inputs) {
      const key = `${i.name}::${i.value}`;
      if (seen.has(key)) continue;
      seen.add(key);
      out.push(i);
    }
    return out;
  }

  function getLabelTextForInput(input) {
    if (!input) return "";
    const inLabel = input.closest("label");
    if (inLabel) return (inLabel.textContent || "").replace(/\s+/g, " ").trim();
    if (input.id) {
      const lab = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (lab) return (lab.textContent || "").replace(/\s+/g, " ").trim();
    }
    return (input.value || "").replace(/\s+/g, " ").trim();
  }

  function hideOriginalFilterDetails(inputs) {
    const detailsSet = new Set();
    inputs.forEach(inp => {
      const d = inp.closest("details");
      if (d) detailsSet.add(d);
    });
    detailsSet.forEach(d => d.classList.add("gsw-hide-original"));
  }

  function tryAutoSubmit(origInput) {
    const form =
      origInput.closest("form") ||
      origInput.closest("facet-filters-form") ||
      origInput.closest("#FacetFiltersForm");
    if (!form) return;

    const submitBtn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]') ||
      form.querySelector(".facets__apply") ||
      form.querySelector('[name="apply"]');

    if (submitBtn && submitBtn.offsetParent !== null) {
      submitBtn.click();
      return;
    }

    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
  }

  function syncToOriginal(origInput, checked) {
    origInput.checked = checked;
    origInput.dispatchEvent(new Event("input", { bubbles: true }));
    origInput.dispatchEvent(new Event("change", { bubbles: true }));
    tryAutoSubmit(origInput);
  }

  function buildCard(title, inputs) {
    const card = document.createElement("div");
    card.className = "gsw-filter-card";
    card.innerHTML = `<div class="gsw-filter-title">${title}</div><div class="gsw-filter-body"></div>`;
    const body = card.querySelector(".gsw-filter-body");
    function bindTapToToggle(el, toggle) {
      let startX = 0, startY = 0;
      let moved = false;
      let active = false;

      el.addEventListener("pointerdown", (e) => {
        // tik primary touch/click
        if (e.isPrimary === false) return;
        if (e.pointerType === "mouse" && e.button !== 0) return;

        active = true;
        moved = false;
        startX = e.clientX;
        startY = e.clientY;
      }, true);

      el.addEventListener("pointermove", (e) => {
        if (!active) return;
        const dx = Math.abs(e.clientX - startX);
        const dy = Math.abs(e.clientY - startY);
        if (dx > 10 || dy > 10) moved = true;
      }, true);

      el.addEventListener("pointerup", (e) => {
        if (!active) return;
        active = false;

        // jei buvo scroll/swipe – nieko nedarom
        if (moved) return;

        // čia jau tikras tap/click
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        toggle();
      }, true);

      el.addEventListener("pointercancel", () => {
        active = false;
      }, true);
    }

    inputs.forEach((origInput) => {
      const row = document.createElement("div");
      row.className = "gsw-opt";

      const ui = document.createElement("input");
      ui.type = "checkbox";
      ui.checked = !!origInput.checked;

      const text = document.createElement("span");
      text.textContent = getLabelTextForInput(origInput) || origInput.value || "—";

      function toggle() {
        const next = !ui.checked;
        ui.checked = next;
        syncToOriginal(origInput, next);
      }

      // THE IMPORTANT PART: pointerdown in capture => works 1st click in Theme Editor
      let startY = 0;
let moved = false;

function touchStart(e) {
  const t = e.touches && e.touches[0];
  if (!t) return;
  startY = t.clientY;
  moved = false;
}

function touchMove(e) {
  const t = e.touches && e.touches[0];
  if (!t) return;
  if (Math.abs(t.clientY - startY) > 10) moved = true;
}

// fiksuojam ar buvo scroll
row.addEventListener("touchstart", touchStart, { passive: true });
row.addEventListener("touchmove", touchMove, { passive: true });
ui.addEventListener("touchstart", touchStart, { passive: true });
ui.addEventListener("touchmove", touchMove, { passive: true });

// toggle tik per CLICK (o ne per touch/pointerdown)
row.addEventListener("click", (e) => {
  if (moved) return; // jei braukė – nedarom nieko
  e.preventDefault();
  e.stopPropagation();
  toggle();
}, true);

ui.addEventListener("click", (e) => {
  if (moved) return;
  e.preventDefault();
  e.stopPropagation();
  toggle();
}, true);


      row.appendChild(ui);
      row.appendChild(text);
      body.appendChild(row);
    });

    return card;
  }

  function findInsertAnchor() {
    return (
      document.querySelector("#ProductGridContainer") ||
      document.querySelector(".product-grid-container") ||
      document.querySelector(".collection") ||
      document.querySelector("#MainContent") ||
      document.querySelector("main")
    );
  }

  function renderTopFilters() {
    if (!isCollectionPage()) return;

    injectStyles();

    const root = pickSourceRoot();
    if (!root) return;

    let typeInputs = dedupeInputs(findInputsInRoot(root, "filter.p.product_type"));
    let vendorInputs = dedupeInputs(findInputsInRoot(root, "filter.p.vendor"));

    if (!typeInputs.length && !vendorInputs.length) return;

    let box = document.querySelector(".gsw-filters-top");
    const anchor = findInsertAnchor();
    if (!anchor || !anchor.parentNode) return;

    if (!box) {
      box = document.createElement("div");
      box.className = "gsw-filters-top";
      box.innerHTML = `
        <div class="gsw-filters-top-head">Filtrai</div>
        <div class="gsw-filters-top-grid">
          <div class="gsw-slot-type"></div>
          <div class="gsw-slot-vendor"></div>
        </div>
      `;
      anchor.parentNode.insertBefore(box, anchor);
    }

    const slotType = box.querySelector(".gsw-slot-type");
    const slotVendor = box.querySelector(".gsw-slot-vendor");
    slotType.innerHTML = "";
    slotVendor.innerHTML = "";

    if (typeInputs.length) slotType.appendChild(buildCard("Prekės tipas", typeInputs));
    if (vendorInputs.length) slotVendor.appendChild(buildCard("Prekinis ženklas", vendorInputs));

    if (typeInputs.length) hideOriginalFilterDetails(typeInputs);
    if (vendorInputs.length) hideOriginalFilterDetails(vendorInputs);
  }

  function init() {
    if (!isCollectionPage()) return;

    renderTopFilters();

    const mo = new MutationObserver(() => {
      if (!window.__gsw_mo_t) {
        window.__gsw_mo_t = setTimeout(() => {
          window.__gsw_mo_t = null;
          renderTopFilters();
        }, 150);
      }
    });
/*
const mo = new MutationObserver(() => {
  if (!window.__gsw_mo_t) {
    window.__gsw_mo_t = setTimeout(() => {
      window.__gsw_mo_t = null;
      renderTopFilters();
    }, 150);
  }
});

const observeTarget =
  document.querySelector("#ProductGridContainer") ||
  document.querySelector("#FacetFiltersForm") ||
  document.querySelector("main") ||
  document.body;

mo.observe(observeTarget, { childList: true, subtree: true });
*/
mo.observe(observeTarget, { childList: true, subtree: true });

    window.addEventListener("load", renderTopFilters);
    setTimeout(renderTopFilters, 250);
    setTimeout(renderTopFilters, 800);
    setTimeout(renderTopFilters, 1500);
  }

  if (oncePerPage("gsw_top_filters_1click_narrow")) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
    else init();
  }
})();
